import React, { useEffect } from 'react';
import { useAppSelector } from 'hooks';

import 'styles/App.css';

import { ToastProvider } from '~libs/toast';

import ToastHost from '~components/ToastHost';

import { selectForceRedirect } from '~main/selectors/login';

import AppRoutes from './components/AppRoutes';

const App: React.FC = () => {
  const REDIRECT_URL = process.env.REACT_APP_TPONE_URL;
  const forceRedirect = useAppSelector(selectForceRedirect);

  useEffect(() => {
    if (forceRedirect && REDIRECT_URL) {
      window.location.href = REDIRECT_URL;
    }
  }, [forceRedirect]);

  return (
    <ToastProvider>
      <AppRoutes />
      <ToastHost />
    </ToastProvider>
  );
};

export default App;
